import { useQuery } from '@tanstack/react-query';

import { fetchEscritorios, type EscritorioResumo } from '../api/client';
import { queryKeys } from '../lib/pwa/queryConfig';
import { queryPersistMeta } from '../lib/pwa/queryPersistence';
import { useAuth } from './useAuth';

export function useEscritorios() {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  return useQuery<EscritorioResumo[]>({
    queryKey: [...queryKeys.escritorios.all, userId],
    enabled: !!userId,
    meta: queryPersistMeta.nonEmpty,
    queryFn: fetchEscritorios,
    staleTime: 5 * 60 * 1000,
  });
}
